import { cn } from "@/lib/utils";

/**
 * The table shell for admin lists (students, classrooms, members,
 * donations). Scrolls sideways on narrow screens instead of breaking the
 * page, and follows DESIGN.md: cream header, tabular numbers, row borders
 * instead of stripes, a faint clay tint on hover.
 *
 *   <DataTable>
 *     <thead><tr><Th>Name</Th><Th align="right">Raised</Th></tr></thead>
 *     <tbody><tr className={rowClass}><Td>…</Td></tr></tbody>
 *   </DataTable>
 */
export function DataTable({ children, className }) {
  return (
    <div className={cn("overflow-hidden rounded-xl border border-border bg-card", className)}>
      {/* relative: screen-reader-only headers are absolutely positioned and
          would otherwise escape the scroller and widen the whole page. */}
      <div className="relative overflow-x-auto">
        <table className="w-full text-sm font-tabular">{children}</table>
      </div>
    </div>
  );
}

const ALIGN = { left: "text-left", right: "text-right", center: "text-center" };

export function Th({ children, align = "left", className, srOnly = false }) {
  return (
    <th
      scope="col"
      className={cn(
        "whitespace-nowrap border-b border-border bg-background px-4 py-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground",
        ALIGN[align],
        className
      )}
    >
      {srOnly ? <span className="sr-only">{children}</span> : children}
    </th>
  );
}

export function Td({ children, align = "left", className, ...props }) {
  return (
    <td className={cn("px-4 py-3", ALIGN[align], className)} {...props}>
      {children}
    </td>
  );
}

// For <tr>: a divider between rows and the hover tint.
export const rowClass = "border-b border-border last:border-0 transition-colors hover:bg-primary/5";

// A full-width message row ("No students match").
export function EmptyRow({ colSpan, children }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-10 text-center text-sm text-muted-foreground">{children}</td>
    </tr>
  );
}
